'use es6';

export const editorFilesToPrefetchByPackage = {
  ['page-editor-ui']: ['bundles/project.js', 'sass/project.css'],
  InpageEditorUI: ['bundles/app.js', 'bundles/app.css'],
  'head-dlb': ['bundle.production.js']
};